module.exports = __webpack_public_path__ + "assets/img/6032673758d4a1788db33b89fca6a7e9.png";